import { useTranslation } from 'react-i18next';

import { StatusPageActions } from './StatusPageActions';
import HsStatusPage from 'src/components/common/hs/HsStatusPage';
import useDocumentTitle from 'src/hooks/common/document-title';

/** 없는 주소. 모든 서비스의 `*` 라우트와 `/404` */
export default function NotFoundPage() {
  const { t } = useTranslation();
  useDocumentTitle('404');

  return (
    <HsStatusPage code="404" title={t('hs.not-found-title')} description={t('hs.not-found-desc')}>
      <StatusPageActions />
    </HsStatusPage>
  );
}
